/*
  <cart-recommendations data-product-id="123" data-limit="3" data-intent="related">
    Empty placeholder. JS fetches the cart-recommendations section
    based on the first cart product, renders the result, and wires
    up the add-to-cart buttons (with variant selection) so they add
    the product to the cart and refresh the cart drawer.
*/

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productId = this.dataset.productId;
    this.limit = this.dataset.limit || 10;
    this.intent = this.dataset.intent || 'related';

    if (!this.productId) return;

    this.loadRecommendations();
  }

  loadRecommendations() {
    const url =
      '/recommendations/products' +
      '?section_id=cart-recommendations' +
      '&product_id=' + encodeURIComponent(this.productId) +
      '&limit=' + encodeURIComponent(this.limit) +
      '&intent=' + encodeURIComponent(this.intent);

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const block = html.querySelector('.cart-recommendations');

        if (!block) {
          this.innerHTML = '';
          return;
        }

        this.innerHTML = block.outerHTML;
        this.bindEvents();
      })
      .catch((e) => {
        console.error('Cart recommendations failed to load:', e);
      });
  }

  bindEvents() {
    const items = this.querySelectorAll('.cart-rec');

    items.forEach((item) => {
      const select = item.querySelector('[data-variant-select]');
      const button = item.querySelector('[data-add-button]');
      const priceEl = item.querySelector('[data-price-target]');

      if (select && button) {
        select.addEventListener('change', () => {
          const selectedOption = select.options[select.selectedIndex];
          button.dataset.variantId = selectedOption.value;

          if (priceEl && selectedOption.dataset.price) {
            this.animatePriceChange(priceEl, selectedOption.dataset.price);
          }

          if (selectedOption.disabled) {
            button.setAttribute('disabled', '');
          } else {
            button.removeAttribute('disabled');
          }
        });
      }

      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.addToCart(button);
        });
      }
    });
  }

  animatePriceChange(priceEl, newPrice) {
    priceEl.style.transition = 'opacity 0.15s ease, transform 0.15s ease';
    priceEl.style.opacity = '0';
    priceEl.style.transform = 'translateY(-3px)';

    setTimeout(() => {
      priceEl.innerHTML = newPrice;
      priceEl.style.transform = 'translateY(3px)';
      requestAnimationFrame(() => {
        priceEl.style.opacity = '1';
        priceEl.style.transform = 'translateY(0)';
      });
    }, 150);
  }

  addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.hasAttribute('disabled') || button.classList.contains('is-loading')) {
      return;
    }

    button.classList.add('is-loading');

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : [];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Add to cart error:', response.description);
          button.classList.remove('is-loading');
          return;
        }

        button.classList.remove('is-loading');
        button.classList.add('is-success');

        setTimeout(() => {
          if (cartDrawer && response.sections) {
            cartDrawer.renderContents(response);
          } else if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-recommendations',
              cartData: response,
            });
          }
        }, 350);
      })
      .catch((e) => {
        console.error('Failed to add recommended product:', e);
        button.classList.remove('is-loading');
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
